import { Typography } from '@mui/material';

import styles from './CmdKTag.module.scss';
import { useGetOSMetaKey } from '@/hooks/useGetOSMetaKey';

export const CmdKTag = () => {
  const metaKey = useGetOSMetaKey();

  return (
    <div className={styles.CmdKTag}>
      <Typography variant="bodySemiBold">{metaKey} + K</Typography>
    </div>
  );
};
